import { render, staticRenderFns } from "./TinyBoxComponent.vue?vue&type=template&id=2fac88cc"
import script from "./TinyBoxComponent.vue?vue&type=script&lang=js"
export * from "./TinyBoxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports